import create from 'zustand'
import merge from 'lodash.merge'

export const loadsInitialData = []
const useLoadsStore = create((set) => ({
  loads: loadsInitialData,
  loadsLoading: true,
  setLoadsLoading: (loading) => set({ loadsLoading: loading }),
  setLoads: (loads) => set((state) => ({ ...state, loads, loadsLoading: false })),
  resetLoads: () => set(() => ({
    loads: loadsInitialData,
    loadsLoading: true
  })),
  addLoad: (load) => set(state => ({ ...state, loads: state?.loads ? [load, ...state.loads] : [load] })),
  deletePost: (id) => set((state) => ({
    ...state,
    loads: state.loads.filter((item) => item.matchedLoad?.id !== id)
  })),
  updateSpecificLoad: (id, data) => set((state) => ({
    ...state,
    loads: state.loads.map((item) => (item.matchedLoad?.id === id ? merge(item, data) : item))
  })),
  setSpecificLoad: (id, data) => set((state) => ({
    ...state,
    loads: state.loads.map((item) => (item.matchedLoad?.id === id ? { ...item, matchedLoad: data } : item))
  }))
}))

export default useLoadsStore
